//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.ShipDesign.FeatureParmsBuilder.js";
import "../Features/Features.ShipDesign.EndCutBuilder.js";
import "../Features/Features.ShipDesign.PillarTreatmentBlockBuilder.js";
import "../no/Expression.js";
import "../no/SelectCurve.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../Features/Features.ShipDesign.PlateStockBuilder.js";
import "../Features/Features.ShipDesign.StiffenerStockBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"EndCutEnd",1,0],[0,"EndCutStart",1,0],[1,"EndEndCut",0,"Features.ShipDesign.EndCutBuilder",0],[0,"EndEndCutChanged",1,0],[1,"EndPillarTreatment",0,"Features.ShipDesign.PillarTreatmentBlockBuilder",0],[0,"MountingMethod",1,0],[0,"Name",1,0],[1,"Offset",0,"Expression",0],[1,"OrientationAngle",0,"Expression",0],[1,"OrientationLinePillar",0,"SelectCurve",0],[0,"OrientationMethod",1,0],[0,"OrientationVector",1,"Direction",0],[1,"PillarStockData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[1,"PlateStockData",0,"Features.ShipDesign.PlateStockBuilder",0],[1,"ProfileStockData",0,"Features.ShipDesign.StiffenerStockBuilder",0],[0,"Reverse",1,0],[1,"StartEndCut",0,"Features.ShipDesign.EndCutBuilder",0],[0,"StartEndCutChanged",1,0],[1,"StartPillarTreatment",0,"Features.ShipDesign.PillarTreatmentBlockBuilder",0],[1,"SubSystem",0,"SelectNXObjectList",0],[0,"Tightness",1,0]],[],[]];
SPLM.Features.ShipDesign.SubSystemBuilder = class extends SPLM.Features.ShipDesign.FeatureParmsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SubSystemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;